module.exports = __webpack_public_path__ + "assets/images/rafal_video.jpg";